import type { CSSProperties } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement.js';
import type { ConnectedAccountsModalElementProps } from './ConnectedAccountsModalElement.types.js';

export function ConnectedAccountsModalElement({
  isOpen,
  onOpenChange,
  title,
  message,
  closeLabel,
  children,
}: ConnectedAccountsModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={() => onOpenChange(false)}
      className="shadow-lg overflow-hidden sm:rounded-md bg-white"
      style={generatedStyle}
      showRoundedBorders={false}
      shouldCloseOnOutsideClick={true}
    >
      <div className="w-full flex flex-col gap-6 p-6">
        <div className="flex flex-col gap-1 w-full">
          <h1 className={classNames('text-gray-900 text-lg font-bold leading-7 w-full text-left')}>{title}</h1>
          <p className={classNames('text-gray-500 text-sm font-normal leading-5 w-full text-left')}>{message}</p>
        </div>
        {children}
        <div className="flex justify-end">
          <ButtonElement onClick={() => onOpenChange?.(false)} type="button" variant="default">
            {closeLabel}
          </ButtonElement>
        </div>
      </div>
    </SimpleModal>
  );
}
